<template>
  <v-container fluid>
    <v-app-bar class="appbar" :density="$vuetify.display.smAndDown ? 'compact' : 'prominent'" color="background">
      <div class="v-center text-right pr-6">
        <router-link v-if="!authed && $vuetify.display.mdAndUp" to="/sign-in">Sign in</router-link>
      </div>
      <!-- <v-row align="center">
        <v-col cols="12" class="d-flex justify-center align-center">
        </v-col>
      </v-row> -->
    </v-app-bar>
    <router-link v-if="!authed && $vuetify.display.smAndDown" to="/sign-in" class="mobile-signin">Sign in</router-link>
  </v-container>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { mapGetters, mapState } from 'vuex'
import { useRouter } from 'vue-router'
const router = useRouter()

@Options({
  computed: {
    ...mapState(['username', 'authenticated']),
    breakpoint() {
      return this.$vuetify.display.name
    }
  },
  watch: {
    breakpoint(value: any) {
      this.hide()
    },
    authenticated(value: boolean) {
      if (value) {
        this.$router.push('/stonks')
      } else {
        this.$router.push('/')
      }
    }
  }
})
export default class NavComponent extends Vue {
  public authenticated!: boolean
  public breakpoint!: string
  public $vuetify: any
  // shouldHide = false

  get authed() {
    return this.authenticated ?? false
  }

  mounted() {
  }

  shouldHide(cols: string[]) {
    const bp = this.breakpoint ?? ''
    if (cols.includes(bp)) {
      return false
    }
    return true
  }
  
  shouldShow(cols: string[]) {
    const bp = this.breakpoint ?? ''
    if (cols.includes(bp)) {
      return true
    }
    return false
  }

  hide(): boolean {
    const bp = this.breakpoint ?? ''
    console.log(bp)
    if (bp === 'xs' || bp === 'sm' || bp === 'md') {
      return true
    }
    return false
  }

}
</script>
<style scoped lang="scss">
.v-tooltip :deep(.v-overlay__content) {
  // background-color: #a6fbf697 !important;
  font-size: 12px !important;
  font-weight: bold !important;
}
.col-center {
  text-align: center;
}

.banner {
  background-color: #000f18;
}
.v-app-bar.v-toolbar.appbar {
  background-image: url('@/assets/stonk-report-header.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: min(100%, 900px);
  overflow: hidden;
}
// .header-img {
//   max-width: 1054px;
//   width: 100%;
//   height: auto;
// }
// .offset-image {
//   margin-left: 26px;
//   margin-top: -200px;
//   margin-right: -26px;
// }

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &:visited {
      color: #2c3e50;
    }

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.v-center {
  // text-align: right;
  align-content: center;
  display: block;
  height: 100%;
  width: 100%;
}

.mobile-signin {
  position: absolute;
  top: 60px;
  right: 20px;
}

</style>